
<template>
  <div>
    <MainToolbar v-bind:notif="notif" v-bind:objDialog="objDialog"></MainToolbar>
    <v-content>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex md2 xs12 ma-1>
            <v-text-field name="userName" v-model="userName" label="User Name" id="userName"></v-text-field>
          </v-flex>
          <v-flex md2 xs12 ma-1>
            <v-text-field name="action" v-model="action" label="Action" id="action"></v-text-field>
          </v-flex>
          <v-flex md2 xs12 ma-1>
            <v-text-field name="field" v-model="field" label="Field" id="field"></v-text-field>
          </v-flex>
          <v-flex md2 xs12 ma-1>
            <v-text-field
              name="entity"
              v-model="entity"
              label="Entity"
              id="entity"
            ></v-text-field>
          </v-flex>
          <v-flex md2 xs12 ma-1>
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateFormatted"
                  label="Date"
                  readonly
                  hint="YYYY/MM/DD format"
                  persistent-hint
                  prepend-icon="event"
                  @blur="date = parseDate(dateFormatted)"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-btn color="green white--text" @click.native="searchAudit">Search</v-btn>
        </v-layout>
        <v-progress-linear :indeterminate="true" height="5" color="green" v-if="actioninProgress"></v-progress-linear>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="auditLogs"
          :pagination.sync="pagination"
          :search="search"
          :rows-per-page-items="[10,20,35]"
          :custom-sort="customSort"
          class="elevation-1"
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="['column', header.sortable == false ? '' : 'sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '', header.visibility]"
                @click="header.sortable != false && changeSort(header.value)"
              >
                <v-icon small v-show="header.sortable != false">arrow_upward</v-icon>
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.item.Username }}</td>
            <td class="text-xs-center">{{ props.item.Action }}</td>
            <td class="text-xs-center">{{ props.item.Field }}</td>
            <td class="text-xs-center">{{ props.item.OldValue }}</td>
            <td class="text-xs-center">{{ props.item.NewValue }}</td>
            <td class="text-xs-center">{{ props.item.Entity }}</td>
            <td class="text-xs-center">{{formatDateGrid(props.item.DateTime)}}</td>
          </template>
          <template slot="no-data">Sorry, nothing to display here.</template>
          Your search for "{{ search }}" found no results.
        </v-data-table>
        <v-progress-linear :indeterminate="true" height="5" color="green" v-if="loading"></v-progress-linear>
      </v-container>
    </v-content>
  </div>
</template>
<script>
import DataService from '@/services/data-service';
import moment from 'moment';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import MainToolbar from '@/components/MainToolbar.vue';

const dataService = new DataService();

export default {
  name: 'audit',
  props: [],
  components: {
    MainToolbar,
  },
  data: vm => ({
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu1: false,
    menu2: false,
    validateuserForm: false,
    dialog: false,
    dialogDetails: false,
    notif: {
      color: 'success',
      message: '',
      show: false,
    },
    objDialog: {
      dialog_title: '',
      dialog_body: '',
      btn_ok_text: 'Ok',
      btn_cancel_text: 'Cancel',
      show: false,
      result: undefined,
    },
    userName: '',
    action: '',
    entity: '',
    field: '',
    dialogDetailsAction: null,
    loading: false,
    actioninProgress: false,
    editedIndex: -1,
    search: '',
    pagination: {
      descending: true,
      sortBy: 'DateTime',
    },

    selected: [],
    headers: [
      {
        text: 'User Name',
        value: 'Username',
        align: 'left',
        width: '1%',
        visibility: 'hidden-xs-only',
      },
      {
        text: 'Action',
        value: 'Action',
        align: 'left',
        width: '1%',
        visibility: 'hidden-xs-only',
      },
      {
        text: 'Field',
        value: 'Field',
        align: 'left',
        width: '1%',
      },
      {
        text: 'Old Value',
        value: 'OldValue',
        align: 'left',
        width: '1%',
        visibility: 'hidden-xs-only',
      },
      {
        text: 'New Value',
        value: 'NewValue',
        align: 'left',
        width: '1%',
        visibility: 'hidden-xs-only',
      },
      {
        text: 'Entity',
        value: 'Entity',
        align: 'left',
        width: '1%',
        visibility: 'hidden-xs-only',
      },
      {
        text: 'Date Time',
        value: 'DateTime',
        align: 'left',
        width: '1%',
        visibility: 'hidden-xs-only',
      },
    ],
    auditLogs: [],
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New User' : 'Edit User';
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },

  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
    },
    $route(to, from) {
      console.log(to.params.id);
      this.initialize();
    },
  },
  beforeRouteUpdate(to, from, next) {
    // react to route changes...
    // don't forget to call next()
    next();
  },

  created() {
    this.initialize();
  },
  methods: {
    showNotif(obj) {
      const that = this;
      that.notif.show = true;
      that.notif.message = obj.message;
      that.notif.color = obj.color;
    },
    initialize() {
      if (!this.$store.getters.getIsAuthenticated) {
        this.Logout();
      } else {
        this.getDataFromServer();
      }
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${year}/${month}/${day}`;
    },
    parseDate(date) {
      if (!date) return null;
      const newDate = date.split('-').join('/');
      const [year, month, day] = newDate.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    formatDateGrid(val) {
      const date = new Date(val);
      const month = date.getMonth() + 1;
      return `${date
        .getFullYear()
        .toString()
        .padStart(2, '0')}-${month.toString().padStart(2, '0')}-${date
        .getDate()
        .toString()
        .padStart(2, '0')}
      ${date
    .getHours()
    .toString()
    .padStart(2, '0')}:${date
  .getMinutes()
  .toString()
  .padStart(2, '0')}:${date
  .getSeconds()
  .toString()
  .padStart(2, '0')}
      `;
      // return val.toString("yyyy-MM-dd hh:mm:ss");
    },
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        const sortA = a[index];
        const sortB = b[index];
        if (isDesc) {
          if (sortA < sortB) return 1;
          if (sortA > sortB) return -1;
          return 0;
        }
        if (sortA < sortB) return -1;
        if (sortA > sortB) return 1;
        return 0;
      });
      return items;
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    searchAudit() {
      const that = this;
      // return new Promise((resolve, reject) => {
      //   debugger
      // if(this.userName == '' && this.entity == '' && this.action == '' & this.field == '' && this.dateFormatted == null){
      //        this.getDataFromServer();
      // }
      // else {
      dataService
        .searchAudit(
          this.userName,
          this.entity,
          this.action,
          this.field,
          this.dateFormatted,
        )
        .then((auditLogs) => {
          this.auditLogs = auditLogs;
        })
        .catch((error) => {});
      // }
      // })
    },
    done() {
      this.actioninProgress = true;
      if (!this.$refs.userForm.validate()) {
        this.actioninProgress = false;
      }
    },
    getDataFromServer() {
      return new Promise((resolve, reject) => {
        const {
          sortBy, descending, page, rowsPerPage,
        } = this.pagination;

        this.loading = true;
        dataService.getAudit().then((auditLogs) => {
          const total = auditLogs.length;
          this.loading = false;
          if (this.pagination.sortBy) {
            // eslint-disable-next-line
            auditLogs.data = auditLogs.sort((a, b) => {
              const sortA = a[sortBy];
              const sortB = b[sortBy];

              if (descending) {
                if (sortA < sortB) return 1;
                if (sortA > sortB) return -1;
                return 0;
              }
              if (sortA < sortB) return -1;
              if (sortA > sortB) return 1;
              return 0;
            });
          }
          this.auditLogs = auditLogs;
          console.log(auditLogs);
        });
      });
    },
  },
};
</script>
<style scoped>
.container {
  padding-top: 2px;
  padding-bottom: 2px;
}
.cell-font-size {
  font-size: 12px;
}

@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";

.router-anim-enter-active {
  animation: coming 1s;
  animation-delay: 0.5s;
  opacity: 0;
}
.router-anim-leave-active {
  animation: going 1s;
}

@keyframes going {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50px);
    opacity: 0;
  }
}
@keyframes coming {
  from {
    transform: translateX(-50px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  padding: 0 10px;
}
</style>
